import firebase from "firebase";
const config = {
    apiKey: "AIzaSyAeJ9SnNp0oncgwhtpIDfw99NZAURJ_Tq8",
    authDomain: "garethhenriksen-footballfever.firebaseapp.com",
    databaseURL: "https://garethhenriksen-footballfever.firebaseio.com",
    projectId: "garethhenriksen-footballfever",
    storageBucket: "garethhenriksen-footballfever.appspot.com",
    messagingSenderId: "587830234784",
    appId: "1:587830234784:web:22e89d6b1a0a48fd"
};
firebase.initializeApp(config);

export default firebase;
